import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { getSortedPosts } from "@/data/blogPosts";

const Blog = () => {
  const posts = getSortedPosts();

  return (
    <>
      <Helmet>
        <title>Nutrition Blog | Functional Foodie Dietitians Johannesburg</title>
        <meta
          name="description"
          content="Evidence-based nutrition articles from a registered dietitian in Johannesburg — gut health, weight management, chronic disease, pregnancy and more."
        />
        <link rel="canonical" href="https://functionalfoodie.co.za/blog" />
        <meta property="og:title" content="Nutrition Blog | Functional Foodie" />
        <meta
          property="og:description"
          content="Evidence-based nutrition articles from a registered dietitian in Johannesburg."
        />
        <meta property="og:url" content="https://functionalfoodie.co.za/blog" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Functional Foodie Nutrition Blog",
          url: "https://functionalfoodie.co.za/blog",
          author: {
            "@type": "Person",
            name: "Dalya Hockman",
            jobTitle: "Registered Dietitian",
          },
          blogPost: posts.map((p) => ({
            "@type": "BlogPosting",
            headline: p.title,
            datePublished: p.date,
            url: `https://functionalfoodie.co.za/blog/${p.slug}`,
          })),
        })}</script>
      </Helmet>

      <section className="pt-52 md:pt-40 pb-12 bg-accent/30">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Nutrition Blog
          </h1>
          <p className="text-lg text-primary/80 max-w-2xl mx-auto">
            Evidence-based articles from a registered dietitian in Johannesburg —
            gut health, weight management, chronic disease, pregnancy and the
            questions clients ask me most.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
            {posts.map((post) => (
              <article
                key={post.slug}
                className="bg-white rounded-lg shadow-sm hover:shadow-lg transition-shadow border border-border overflow-hidden flex flex-col"
              >
                <div className="p-6 flex flex-col flex-grow">
                  <div className="text-xs uppercase tracking-wide text-secondary font-semibold mb-2">
                    {post.category}
                  </div>
                  <h2 className="text-xl font-semibold text-primary mb-3 leading-snug">
                    <Link
                      to={`/blog/${post.slug}`}
                      className="hover:text-secondary transition-colors"
                    >
                      {post.title}
                    </Link>
                  </h2>
                  <p className="text-sm text-primary/70 mb-4 flex-grow">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between mt-auto pt-4 border-t border-border">
                    <time
                      dateTime={post.date}
                      className="text-xs text-primary/60"
                    >
                      {new Date(post.date).toLocaleDateString("en-ZA", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </time>
                    <Link
                      to={`/blog/${post.slug}`}
                      className="text-sm font-medium text-secondary hover:underline"
                    >
                      Read more →
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;